<!--
 * @Author: Gaho
 * @Date: 2024-06-07 15:55:03
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-01 16:51:32
 * @Description: 
-->
<template>
    <ModalTitle
        footer-class=""
        :model-value="modelValue"
        container-class="!w-[360px] max-w-[96vw]"
        @update:model-value="handleUpdateModelValue"
    >
        <template #header>
            <span class="text-[24px] leading-10">
                {{ 
                    all 
                    ? $t('waves.closeAllTitle') 
                    : $t('waves.closeOneTitle') 
                }}
            </span>
        </template>
        <!-- ↑ 标题 -->
        <!-- ↓ 正文 -->
        <div class="description">
            {{ 
                all 
                ? $t('waves.closeAll') 
                : $t('waves.closeOne') 
            }}
        </div>
        <template v-slot:footer>
            <!-- ↓ Don't show again --> 
            <label class="footer__checkbox checkbox checkbox_lg h8"
                :class="{'checkbox_checked': doNotShowAgain}" 
            > 
                <input class="checkbox__input" 
                    type="checkbox"
                    v-model="doNotShowAgain"
                > 
                <span class="checkbox__label"> 
                    {{ $t('waves.DoNotShow') }} 
                </span> 
            </label>
            <!-- 
                ↑ 提示语
                ↓ 操作按钮：取消 | 提现 
            --> 
            <div class="btn-group">
                <button class="button-flat button-flatmd button-flat_grey1 button-flat_center button-flat_fullwidth"
                    @click="fnProcessDecision(false)"
                    type="button"
                >
                    <span class="button-flat__inner"> 
                        <span class="button-flat__text"> 
                            {{ $t('waves.Cancel') }}
                        </span>
                    </span>
                </button>
                <!-- 
                    ↑ 取消平仓 
                    ↓ 确定执行平仓 
                -->
                <ButtonThe3DButton
                    color="red"
                    size="lg"
                    @click="fnProcessDecision(true)"
                >
                    <div class="text-white items-center text-[14px]">
                        {{ 
                            all 
                            ? $t('waves.AllCashOut') 
                            : $t('waves.CashOut') 
                        }}
                    </div>
                </ButtonThe3DButton>
            </div>
        </template>
    </ModalTitle>
</template>


<script lang="ts" >
export default defineComponent({name: 'WavesCashOutConfirm'}); 
</script>

<script lang="ts" setup>
import { 
    settingsState_f, 
    fnSettingCenter_Ft, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 

const props = defineProps({ 
    modelValue: { // 控制可见性 
        type: Boolean, 
        required: true, 
    },
    all: { // 平仓一项，还是平仓所有项的标识 
        type: Boolean, 
    },
    fnCallback: { // 确认后的回调，用于执行平仓 
        type: Function, 
        required: true, 
    },
});

const doNotShowAgain = ref(false); // 
const oSettingCenter = fnSettingCenter_Ft(); 
const emits = defineEmits(['update:modelValue']); 

// ↓ 保存用户偏好 
const changeUserSettings = ()=>{
    const sKeyName = (
        props.all == true 
        ? 'confirmAllCashOut'
        : 'confirmCashOut'
    );
    // ↓ 标记： 不需要再弹出 
    settingsState_f.userSettings[sKeyName] = false; 
    // ↓ 保存最新的用户偏好，不需要参数 
    oSettingCenter.setUserSettings(); 
};

const fnProcessDecision = (hasConfirmed) => {
    // ↓ 先关闭窗口 
    handleUpdateModelValue(false);
    // ↓ 用户取消了，终止在此，
    if (!hasConfirmed) return; 
    // ↓ 执行平仓（调用父级的方法） 
    props.fnCallback();
    // ↓ 按需要，保存用户偏好 
    if (doNotShowAgain.value == true){
        changeUserSettings();
    }
}

const handleUpdateModelValue = (bNewValue) => {
    emits('update:modelValue', !!bNewValue);
}
</script>


<style scoped lang="scss">
.description{
    color: var(--dark-shades-gray-20, #93acd3);
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    // margin-bottom: 20px;
}

.btn-group{
    display: flex;
    align-items: center;
    justify-content: space-between;
    // margin-top: 20px;
    width: 100%; 
    button{
        width: calc(50% - 5px);
        // flex: 1; 
    }
}

// ↓ 复选框 ==================== 


.button-flat{
    background-color: #ffffff1f;
    border-color: transparent;
    color: #ffffffd6;
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: center;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    display: inline-block;
    position: relative;
    text-align: center;
    text-decoration: none;
    transition: color .1s ease-in-out,background-color .1s ease-in-out,border-color .1s ease-in-out;
    white-space: nowrap;
    height: 48px;
    border-radius: 8px;
    &:hover {
        background-color: #ffffff29;
        color: #fff
    }
}


// ↓ 复选框 ==================== 

.footer__checkbox{ 
    color: white;  
}

.checkbox {
    align-items: center;
    cursor: pointer;
    display: inline-flex;
    margin: 0 0 8px;  
    padding: 0
}

.checkbox:hover .checkbox__input {
    border-color: #ffffff7a
}

.checkbox.checkbox_checked:hover .checkbox__input {
    background-color: var(--Brand-Blue-Transparent);
    border-color: var(--Brand-Blue-Default)
}

.checkbox.checkbox_has-error:hover .checkbox__input {
    background-color: transparent;
    border-color: var(--Brand-Red-Default)
}

.checkbox__input {
    all: unset;
    background-color: transparent;
    border: 2px solid var(--Shades-White-24);
    border-collapse: separate;
    display: block;
    flex-shrink: 0;
    position: relative;
    transition: all .3s
}

.checkbox__input:after {
    border: 2px solid #fff;
    border-inline-start:0;border-top: 0;
    content: "";
    display: table;
    inset-inline-start: 30%;
    opacity: 0;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) scale(0) translate(-50%,-50%);
    transition: all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s
}

.checkbox__label {
    margin-left: .5em;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none
}

.checkbox_checked .checkbox__input {
    background-color: var(--Brand-Blue-Default);
    border-color: var(--Brand-Blue-Default)
}

.checkbox_checked .checkbox__input:after {
    opacity: 1;
    transform: rotate(45deg) scale(1) translate(-50%,-50%);
    transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s
}

.checkbox_has-error .checkbox__input {
    background-color: transparent
}

.checkbox_has-error .checkbox__input,
.checkbox_has-error .checkbox__input:after {
    border-color: var(--Brand-Red-Default)
}

.checkbox_has-error .checkbox__label > * {
    color: var(--Brand-Red-Default)
}

.checkbox_fullwidth {
    width: 100%
}

.checkbox_disabled {
    opacity: .4;
    pointer-events: none
}

.checkbox_lg .checkbox__input {
    border-radius: 6px;
    height: 20px;
    width: 20px
}

.checkbox_lg .checkbox__input:after {
    height: 10px;
    width: 6px
}

.checkbox_md .checkbox__input {
    border-radius: 6px;
    height: 16px;
    width: 16px
}

.checkbox_md .checkbox__input:after {
    height: 8px;
    width: 5px
}

</style>



